import React from "react";
import { type WalletBalanceProps } from "utils/types/wallet.type";
import TotalBalanceCard from "./TotalBalanceCard";
import BalanceTable from "./BalanceTable";

export default function WalletBalance({
  balanceData,
  isLoading,
}: WalletBalanceProps) {
  if (isLoading) {
    return (
      <div className="mt-6">
        <h4 className="text-black-900 text-base font-semibold mb-3">
          Wallet Balances
        </h4>
        <p className="text-black-700 text-sm">Loading balances...</p>
      </div>
    );
  }

  if (!balanceData) {
    return (
      <div className="mt-6">
        <h4 className="text-black-900 text-base font-semibold mb-3">
          Wallet Balances
        </h4>
        <p className="text-black-700 text-sm">No balance data available</p>
      </div>
    );
  }

  return (
    <div className="mt-6">
      <h4 className="text-black-900 text-base font-semibold mb-3">
        Wallet Balances
      </h4>
      {balanceData.totalBalanceInFiat > 0 && (
        <TotalBalanceCard totalBalanceInUsd={balanceData.totalBalanceInUsd} />
      )}
      {balanceData.wallets && balanceData.wallets.length > 0 ? (
        <BalanceTable wallets={balanceData.wallets} />
      ) : (
        <p className="text-black-700 text-sm">
          No balances found for this wallet
        </p>
      )}
    </div>
  );
}

